import React from 'react'
import {
  LineChart, CheckCircle2, Scale, TrendingDown, CalendarRange, BarChart3, ListChecks, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { BACKTEST_METRICS } from '../data'
import { PREVIEWS } from '@/components/landing/home/architecture/previews'
const ICONS = { LineChart, CheckCircle2, Scale, TrendingDown, CalendarRange, BarChart3, ListChecks }
export default function Backtesting() {
  const Backtest = PREVIEWS.backtest
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-12">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Backtesting Engine</Eyebrow>
          <SectionHeading align="center"
            title={<>Deploy strategies <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">only after they survive history.</span></>}
            subtitle="Tick-accurate replay with slippage, latency and commissions modelled. Walk-forward optimisation and Monte-Carlo stress tests are first-class citizens."
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-10">
          <div className="lg:col-span-3">
            <FeatureGrid items={BACKTEST_METRICS} icons={ICONS} cols={2} />
          </div>
          <div className="lg:col-span-2">
            <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-white/[0.01] p-4 backdrop-blur-xl h-full">
              <div className="flex items-center gap-1.5 rounded-md bg-black/40 px-2.5 py-2 border border-white/5 mb-3">
                <div className="h-2 w-2 rounded-full bg-red-500/70" />
                <div className="h-2 w-2 rounded-full bg-amber-500/70" />
                <div className="h-2 w-2 rounded-full bg-emerald-500/70" />
                <div className="ml-3 flex-1 h-5 rounded-md bg-white/[0.04] flex items-center px-2 text-[10px] font-mono text-zinc-500">app.kalkiai.trade/backtest</div>
              </div>
              {Backtest && <Backtest />}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
